module.exports = __webpack_public_path__ + "static/media/campaign-setup.40b43740.png";